import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

import { bingDesktopHeaderImage } from '../media/bing-desktop-header';

const bingDesktopTextRaw = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  key: 'bing_text_desktop',
  className: 'bing_text_desktop',
  type: 'BingTextDesktop',
  associationType: 'BingTextDesktop',
  minimumRequirements: 0,
  localizedText: {
    previewTypeStringKey: _TL_('Bing search ad'),
    stringKey: _TL_(''),
    headerImageAlt: _TL_('Header Image'),
  },
  previewSettings: {
    showLongHeadline: true,
    showDescription: true,
    showUrl: true,
    showMultipleLineLongHeadline: true,
    showUrlMultiline: true,
    showMultipleDescription: true,
    showAdsLabelInlineWithDescription: true,
    showHeaderImage: true,
    headerImage: bingDesktopHeaderImage,
    showPreviewTypeString: false,
  },
  styleOverrides: {
    previewContent: {
      border: 'none',
      boxShadow: 'none',
      width: 530,
      height: 110,
      padding: '8px 16px',
    },
    adsLabel: {
      border: '1px solid #ddd',
      padding: '0 2px',
      fontSize: 11,
      fontWeight: 600,
      lineHeight: 1,
      borderRadius: 6,
      margin: '0 4px 0 0',
      display: 'inline',
      color: '#767676',
      opacity: '100%',
      position: 'static',
      maxHeight: 16,
    },
    textContainer: {
      margin: '4px 8px 0px 8px',
    },
    longHeadline: {
      fontWeight: '400',
      fontSize: '20px',
      lineHeight: '24px',
      height: '28px',
      overflow: 'hidden',
    },
    finalUrl: {
      overflow: 'hidden',
      color: '#0b6a0b',
      fontSize: '14px',
      height: '20px',
    },
    description: {
      color: '#333',
      fontSize: '13px',
      display: 'inline-block',
      flexGrow: 1,
    },
    descriptionParent: {
      display: 'flex',
    },
    headerImage: {
      height: 100,
    },
  },
};

export default bingDesktopTextRaw;
